<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.list.trucks.title')}}</h4>
                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <div class="form-row">
                                    <div class="col-md-11">
                                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.truck.list.label.title')}}</h4></h4>
                                    </div>
                                    <div class="col-md-1" v-if="items">
                                        <h4 class="text-center">{{$t('str.total')}}</h4>
                                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                                    </div>
                                </div>
                                <p class="sub-header">
                                    {{$t('string.msg.truck.search.description')}}
                                </p>
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.truck.search.label.filter')}}
                                            </label>
                                            <select v-model="filters.typeSearch" class="form-control"  @change="onChange(filters.typeSearch)">
                                                <option value="ALL" selected>{{$t('string.msg.list.trucks.type.all')}}</option>
                                                <option value="TRUCK">{{$t('string.msg.truck.label.type.truck')}}</option>
                                                <option value="TRUCK_TRAILER">{{$t('string.msg.truck.label.type.trucktrailer')}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6" v-if="filters.typeSearch != 'ALL'">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucktrailer.register.manufacturs.label')}}
                                            </label>
                                            <select id="manufacturer" v-model="filters.manufacturer" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                                           <download-excel v-if="items && items.length>0 && filters.typeSearch == ('TRUCKS')"
                                                class   = "btn btn-primary"
                                                :fetch   = "fetchData"
                                                :fields = "json_fields"
                                                type    = "csv"
                                                name    = "caminhoes.xls">
                                                Download CSV
                                            </download-excel>
                                            <download-excel v-if="items && items.length>0 && filters.typeSearch == ('TRUCKTRAILERS')"
                                                class   = "btn btn-primary"
                                                :fetch   = "fetchData"
                                                :fields = "json_fields"
                                                type    = "csv"
                                                name    = "carretas.xls">
                                                Download CSV
                                            </download-excel>
                                            <download-excel v-if="items && items.length>0 && (filters.typeSearch == ('') || filters.typeSearch == ('ALL'))"
                                                class   = "btn btn-primary"
                                                :fetch   = "fetchData"
                                                :fields = "json_fields"
                                                type    = "csv"
                                                name    = "carretas-caminhoes.xls">
                                                Download CSV
                                            </download-excel>
                                    </div>
                                </form>

                                 <div class="pb-0 pt-3 ">
                                    <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-centered table-hover mb-0" id="datatable">
                                        <thead >
                                            <tr>
                                                <th class="border-top-0">{{$t('string.msg.truck.table.header.vehicle.type')}}</th>
                                                <th class="border-top-0">{{$t('string.msg.truck.table.header.manufacture')}}</th>
                                                <th class="border-top-0">{{$t('string.msg.truck.table.header.model')}}</th>
                                                <th class="border-top-0">{{$t('string.msg.truck.table.header.year')}}</th>
                                                <th class="border-top-0">{{$t('string.msg.truck.table.header.Placa')}}</th>
                                                <th class="border-top-0">{{$t('string.msg.list.trucks.table.certifieds')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer">
                                            <tr>
                                                <td v-if="item.vehicleType == 'TRUCKTRAILER_DOLLY' || item.vehicleType == 'TRUCKTRAILER_VANDERLEIA' || item.vehicleType == 'TRUCKTRAILER_CONVENCIONAL'">
                                                    <span>  
                                                        {{ $t(item.vehicleType).toString().toUpperCase()}}
                                                    </span>
                                                </td>
                                                 <td v-else>
                                                    <span>  
                                                        {{ $t(item.vehicleType).toString().toUpperCase()}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>  
                                                        {{item.manufacturer.name}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.model && item.model.name">
                                                        {{item.model.name}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>
                                                        {{item.year}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>   
                                                        {{item.plate}}
                                                    </span>
                                                </td>
                                                <td >
                                                    <span v-bind:key="item" v-for="item in item.certifies">   
                                                        {{item.certified.name + ' / '}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Spinner />
         <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
 import Controller from './CrtTrucks';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Trucks',
 
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        manufacturers: [],
        typeVehicle: null,
        pageOfItems: [],
        filters: {
            manufacturer: null,
            typeSearch:'ALL',
            skip: 0,
            limit: 999999
        },
         json_fields: {
            'Tipo':'vehicleType',
            'Fabricante': 'manufacturer.name',
            'Modelo': 'model',
            'Ano': 'year',
            'Placa': 'plate',
        },
        json_data: [
            {
                vehicleType: null,
                manufacturer:{name: null},           
                model: null,
                year: null,
                plate: null,
        }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        listCertifies: [],
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
 
  },
  mounted(){
       
  }
}
</script>

<style>
</style>
